import Konva from "konva";
import {uid} from "uid";
import _, {cloneDeep} from "lodash";
import {SEAT, TextParams} from "../Constants";
import {mainGroups} from "@/core/MainGroups";
import {seatsGroups} from "@/core/SeatsGroup";
import {AppStage} from "@/core/AppStage";
import {updateSection} from "./_generator";
import { checkDeletedSeats } from "../seatUtils";
import { syncPendingSeatEditsToSeatsBind } from "../seatBindSync";
import { setId } from "../utils";

export const bindRowsAndSeats = (configs) => {
  const {
    // name,
    rowSortType,
    rows,
    seatSortType,
    seats,
    dont_show_I,
    dont_show_O,
    // label_left,
    // label_right,
    // rowSpacing,
    // seatSpacing,
    rowStartsWith,
    seatStartsWith,
    seatDirection,
    rowDirection,
    numbers_order
  } = configs;

  // In ABC mode `seatStartsWith` must be letters.
  // If it is a numeric string like "9" (can happen when switching sort types),
  // charCodeAt will produce ':' after '9'. Force a safe default.
  let effectiveSeatStartsWith = seatStartsWith;
  if (seatSortType === "ABC") {
    const seatStartsStr =
      seatStartsWith !== undefined && seatStartsWith !== null
        ? typeof seatStartsWith === "string"
          ? seatStartsWith
          : String(seatStartsWith)
        : "";
    effectiveSeatStartsWith = /^[A-Z]{1,3}$/.test(seatStartsStr)
      ? seatStartsStr
      : "A";
  }

  let rowSeatData = {};
  let sectionSeatsArr = [];
  let idx = 0;

  for (let i = 0; i < rows; i++) {
    let currentRowStartsWith = rowStartsWith ? typeof rowStartsWith === 'number' ? rowStartsWith : rowStartsWith.charCodeAt(0) : 65;
    if(rowSortType === '246' && rowStartsWith && rowStartsWith && rowStartsWith % 2 === 1) {
      currentRowStartsWith += 1
    }
    const charCod = currentRowStartsWith + idx;
  
    if (rowSortType === 'ABC' && ((configs.dont_show_I && charCod == 73) || 
        (configs.dont_show_O && charCod == 79) ||
        (configs.dont_show_II && charCod == 99) || 
        (configs.dont_show_OO && charCod == 105))) {
          idx++
      }

  
    const rowText = bindRows(idx, rowSortType, rowStartsWith, configs);

    rowSeatData[rowText.text] = [];

    let seatIdx = 0;

    for (let j = 0; j < seats; j++) {
      // Defensive fix:
      // In ABC mode `seatStartsWith` must be letters; numeric strings like "9"
      // would produce `':'` after '9' (because of charCodeAt(0)).
      let currentSeatStartsWith = 65;
      if (seatStartsWith !== undefined && seatStartsWith !== null && seatStartsWith !== "") {
        if (seatSortType === "ABC") {
          currentSeatStartsWith = /^[A-Z]{1,3}$/.test(effectiveSeatStartsWith)
            ? effectiveSeatStartsWith.charCodeAt(0)
            : 65;
        } else {
          currentSeatStartsWith =
            typeof seatStartsWith === "number"
              ? seatStartsWith
              : seatStartsWith.charCodeAt(0);
        }
      }

      const charSeatCode = currentSeatStartsWith + seatIdx;

      if (seatSortType === 'ABC' && ((configs.dont_show_I && charSeatCode == 73) || 
          (configs.dont_show_O && charSeatCode == 79) ||
          (configs.dont_show_II && charSeatCode == 99) || 
          (configs.dont_show_OO && charSeatCode == 105))) {
        seatIdx++
      }
  
      const seatText = bindRows(seatIdx, seatSortType, effectiveSeatStartsWith, configs, 'seat');
      rowSeatData[rowText.text].push({
        number: seatText.text,
        id: setId(),
        invalid: false,

      });

      seatIdx++
    }

    idx++
  }

  for (const key in rowSeatData) {
    const element = rowSeatData[key];
    sectionSeatsArr.push({ key, id: setId(), seats: element });
  }

  if (rowDirection === "91") {
    const fliped = flipAndSortKeys(sectionSeatsArr);
    sectionSeatsArr = fliped;
  }

  if (seatDirection === "91") {
    const fliped = flipObject(sectionSeatsArr);
    sectionSeatsArr = fliped;
  }

  return { rowSeatData: sectionSeatsArr };
};

const flipAndSortKeys = (jsonObj) => {
  let newArr = _.cloneDeep(jsonObj);

  const reverse = _.cloneDeep(jsonObj).reverse();

  for (let i = 0; i < reverse.length; i++) {
    newArr[i].key = reverse[i].key;
  }

  return newArr;
};

export const flipObject = (obj) => {
  let newArr = _.cloneDeep(obj);
  
  for (let i = 0; i < newArr.length; i++) {
    if(newArr[i].shift) {
      newArr[i].shift = -newArr[i].shift;
    }
    newArr[i].seats = newArr[i].seats.reverse();
  }
  return newArr;
};

const bindRows = (index, rowSortType, startsWith, configs, type) => {
  let text = "";
  let charCode;
  
  switch (rowSortType) {
    case "ABC":
      charCode = startsWith ? startsWith.charCodeAt(0) + index : 65 + index;

      // if (type === 'seat') {
      //   if (dont_show_IO) {
      //     if (charCode >= 73) {
      //       charCode += 1; // Skip 'I'
      //     }
      //     if (charCode >= 79) {
      //       charCode += 1; // Skip 'O'
      //     }
      //   }
      // }

      if (charCode > 90) {
        const offset = charCode - 91;
        const firstChar = String.fromCharCode(65 + offset);
        const secondChar = String.fromCharCode(65 + offset);
        const thirdChar = String.fromCharCode(65 + offset);
        text = `${firstChar}${secondChar}${thirdChar}`;
      } else {
        let char = String.fromCharCode(charCode);
        text = char;
        if (startsWith.length === 2) {
          text = `${char}${char}`;
        } else if (startsWith.length === 3) {
          text = `${char}${char}${char}`;
        }
      }
      break;
    case "123":

      if (startsWith) {
        text = +startsWith + index ; // concatenate startsWith and index
      } else {
        text = index + 1; // use sequence 1, 2, 3, ..., n * m for row labels
      }

      break;
    case "135":
      if (startsWith) {
        let startsWithVal = startsWith;
        if(startsWith === 0) {
          startsWithVal = 1;
        } else if (startsWith % 2 === 0) {
          startsWithVal = +startsWith - 1;
          // if(type === "seat") {
          //   configs.seatStartsWith = startsWithVal
          // } else {
          //   configs.rowStartsWith = startsWithVal
          // }
        }
        text = +startsWithVal + index * 2 ;
      } else {
        text = index * 2 + 1;
      }

      break;
    case "246":
      if (startsWith) {
        let startsWithVal = startsWith;
        if(startsWith % 2 !== 0) {
          startsWithVal = +startsWith + 1;
          // if(type === "seat") {
          //   configs.seatStartsWith = startsWithVal
          // } else {
          //   configs.rowStartsWith = startsWithVal
          // }
        }
        text = +startsWithVal + index * 2;
      } else {
        text = index + 2;
      }

      break;
    default:
      break;
  }
  return { text, charCode };
};

export const generateRowGroup = (
  i,
  text = '',
  rowLabelX,
  rowLabelY,
  seatRadius,
  rowSpacing,
  // seatSpacing
) => {

  const labelSize = text && text.length > 2 ? text.includes('M') || text.includes('W') ? 16 : 18 : 20;
  
  return {
    id: setId(),
    text,
    fontSize: labelSize,
    fontFamily: "Lato-Bold",
    width: 44,
    height: 35,
    fill: "white",
    align: TextParams.ALIGN_CENTER,
    verticalAlign: "middle",
    align: 'center',
    rowSpacing,
    // letterSpacing: -3,
    offset: {
      x: 22,
      y: 17.5,
    },
  };
};

export const drawSeatGroupBorder = () => {
  let layerBorder = new Konva.Rect({
    type: "border",
    // stroke: "gray",
    strokeWidth: 1,
    dash: [5, 5],
    x: -5,
    y: -5
  });

  let coverLayer = new Konva.Rect({
    type: "cover"
  })

  return { layerBorder, coverLayer };
};

const getRowSeatStartsWith = (rowBind, configs) => {
  const override =
    rowBind?.rowSeatStartsWith !== undefined
      ? rowBind.rowSeatStartsWith
      : rowBind?.tempRowSeatStartsWith;

  if (override !== undefined && override !== null && override !== "") {
    return override;
  }

  return configs.seatStartsWith;
};

export const recoverSectionSeatNumber = (seat, seatsBind, id, configs) => {
  syncPendingSeatEditsToSeatsBind(id);

  const { rowId } = seat;
  const findRow = seatsBind.find((r) => r.id === rowId);
  const seatStartsWith = getRowSeatStartsWith(findRow, configs);
  const returnNumber = findRemovedNumber(seat, seatsBind, {
    ...configs,
    seatStartsWith,
  });
  const rowIndex = seat.attrs.pos[0];
  if(seatsBind[rowIndex].oldKey ) {
    if(!seatsBind[rowIndex].editedKey) {
      seatsBind[rowIndex].key = seatsBind[rowIndex].oldKey;
    }
    
    delete seatsBind[rowIndex].oldKey;
  }
  fillSeatFunction(seat, returnNumber, seatsBind, configs);
 
  updateSection(id, configs);

  return returnNumber;
};

const findRemovedNumber = (seat, seatsBind, configs) => {
  const seatId = seat.getId();

  const { rowId } = seat;
  const { seatSortType, seatDirection, seatStartsWith } = configs;
  const findRow = seatsBind.find((r) => r.id === rowId);
  let findSeatIndex = findRow.seats.findIndex((s) => s.id === seatId);
  const seatsMaxIndex = findRow.seats.length - 1;

  let returnNumber = 0;
  switch (seatSortType) {
    // Todo add cases to constant
    case "123":
      if (seatDirection === "19") {
        returnNumber = +seatStartsWith - 1 + findSeatIndex + 1;
      } else {
        returnNumber =
          seatsMaxIndex - findSeatIndex + 1 + (+seatStartsWith - 1);
      }
      break;
    case "135":
      if (seatDirection === "19") {
        returnNumber = findSeatIndex * 2 + 1 + (+seatStartsWith - 1);
      } else {
        returnNumber =
          (seatsMaxIndex - findSeatIndex) * 2 + 1 + (+seatStartsWith - 1);
      }

      break;
    case "246":
      if (seatDirection === "19") {
        returnNumber = findSeatIndex * 2 + 1 + (+seatStartsWith - 1);
      } else {
        returnNumber =
          (seatsMaxIndex - findSeatIndex) * 2 + 1 + (+seatStartsWith - 1);
      }
      break;
    case "ABC":
      let charCode;
      let text;
      if (seatDirection === "19") {
        charCode = seatStartsWith
          ? seatStartsWith.charCodeAt(0) + findSeatIndex
          : 65 + findSeatIndex;
      } else {
        charCode = seatStartsWith
          ? seatStartsWith.charCodeAt(0) + (seatsMaxIndex - findSeatIndex)
          : 65 + (seatsMaxIndex - findSeatIndex);
      }

      if ((configs.dont_show_I && charCode == 73) || 
          (configs.dont_show_O && charCode == 79) ||
          (configs.dont_show_II && charCode == 99) || 
          (configs.dont_show_OO && charCode == 105)) {
          charCode += 1;
      }

      if (charCode > 90) {
        const offset = charCode - 91;
        const firstChar = String.fromCharCode(65 + offset);
        const secondChar = String.fromCharCode(65 + offset);
        text = `${firstChar}${secondChar}`;
      } else {
        let char = String.fromCharCode(charCode);
        text = char;
      }
      returnNumber = text;
      break;

    default:
      break;
  }

  return returnNumber;
};

const fillSeatFunction = (seat, recoverNumber, seatsBind, configs) => {
  const { rowId } = seat;
  const seatId = seat.getId();
  let numberNode;
  const { seats, seatSpacing } = configs;
  const sectionWidth = (SEAT.size + 5 + 2 * seatSpacing) * seats - 2 * seatSpacing;
  seat.number = recoverNumber;
  seat.setAttrs({number: recoverNumber, deleted: false })
  seat.find((node) => {
    if (node instanceof Konva.Rect) {
      node.setAttrs({
        cornerRadius: 0,
      });

      node.setAttrs({
        stroke: "white",
      });
    } else {
      if (!seat.invalid) {
        node.setAttrs({
          text: recoverNumber
        })

      } else {
        node.setAttrs({
          text: "",
          fontFamily: "icon",
          fontSize: 24,
          width: SEAT.size,
          height: SEAT.size,
          offsetX: SEAT.size/2,
          offsetY: SEAT.size/2
        })
      }
      node.setAttrs({ number: recoverNumber })
      node.visible(true);
      // numberNode = node;
    }
  });

  seat.off("mouseenter");
  seat.off("mouseleave");
  let findRow = seatsBind.find((row) => row.id === rowId);
  let seatItem = findRow.seats.find((s) => s.id === seatId);


  if(seat.attrs.x < 0) {
    findRow.shift = findRow.shift - seat.attrs.x;
  } else if (seat.attrs.x + SEAT.size + 5 >= sectionWidth) {
    const newShift = findRow.shift - (seat.attrs.x + SEAT.size + 5 - sectionWidth); 
    findRow.shift = newShift;
  }
  seatItem.number = recoverNumber;
};


export const mergeArrays = (arr1, arr2, rowDir, seatsDir) => {
  const mergedArray = [];
  const arr2Length = arr2.length;
  let deletedSeats = [];
  for (let i = 0; i < arr2Length; i++) {
  
    const arr2Seat = arr2[i];
    const arr2Next = arr2[i + 1] ? arr2[i + 1] : null;
    const arr2Prev = arr2[i - 1] ? arr2[i - 1] : null;
    const seats = arr2[i].seats;
    const seatLength = arr2[i].seats.length;
   
    const checkEditedLabel = arr1[i] && (arr1[i].editedKey || arr1[i].editedKey === '');
    const emptyLabel = arr1[i] && (arr1[i].oldKey || arr1[i].oldKey === '') ? arr1[i].oldKey : null;
  
    const editedLabel = checkEditedLabel ? arr1[i].editedKey : null;

    if(checkEditedLabel) {
      if(rowDir == '91' && arr1.length != arr2Length) {
        if(arr1.length < arr2Length && arr2Next) {
          arr2Next.key = editedLabel;
          arr2Next.editedKey = editedLabel;
        } else if (arr1.length > arr2Length && arr2Prev) {
          arr2Prev.key = editedLabel;
          arr2Prev.editedKey = editedLabel;
        }
      } else {
        arr2Seat.key = editedLabel;
        arr2Seat.editedKey = editedLabel;
      }
    } 

    if(emptyLabel || emptyLabel === '') {
      if(rowDir == '91' && arr1.length != arr2Length) {
        if(arr1.length < arr2Length && arr2Next) {
          arr2Next.key = emptyLabel;
          arr2Next.oldKey = emptyLabel;
        } else if (arr1.length > arr2Length && arr2Prev) {
          arr2Prev.key = emptyLabel;
          arr2Prev.oldKey = emptyLabel;
        }
      } else {
        arr2Seat.key = emptyLabel;
        arr2Seat.oldKey = emptyLabel;
      }
    } 

    const arr1Index = rowDir === '19' ? i : i - arr2Length + arr1.length ;
    
    if (arr1[arr1Index]) arr2Seat.id = arr1[arr1Index].id;
    if (arr1[arr1Index]) {
      const overrideVal =
        arr1[arr1Index].rowSeatStartsWith !== undefined
          ? arr1[arr1Index].rowSeatStartsWith
          : arr1[arr1Index].tempRowSeatStartsWith;
      if (overrideVal !== undefined) {
        arr2Seat.rowSeatStartsWith = overrideVal;
      }
    }
    if(arr1[arr1Index] && arr1[arr1Index].shift) arr2Seat.shift = arr1[arr1Index].shift;
    for (let j = 0; j < seatLength; j++) {
      const seat = seats[j];
      
      if (arr1[arr1Index]) {
        const seatIndex = seatsDir === '19' ? j : j - seatLength + arr1[arr1Index].seats.length ;
        if (arr1[arr1Index].seats[seatIndex]) {
          seat.id = arr1[arr1Index].seats[seatIndex].id;
          seat.invalid = arr1[arr1Index].seats[seatIndex].invalid;
         
          if (!arr1[arr1Index].seats[seatIndex].number) {
            seat.number = null;
            if(!deletedSeats.includes(arr2)) {
              deletedSeats.push(arr2[arr1Index]);
            }
          } else if (arr1[arr1Index].seats[seatIndex].editedNumber) {
            if(rowDir == '91' && arr1.length != arr2Length) {
              if(arr1.length < arr2Length && arr2Next) {
                arr2Next.seats[j].editedNumber = arr1[arr1Index].seats[seatIndex].editedNumber
              arr2Next.seats[j].number = arr1[arr1Index].seats[seatIndex].editedNumber
              } else if (arr1.length > arr2Length && arr2Prev) {
                arr2Prev.seats[j].editedNumber = arr1[arr1Index].seats[seatIndex].editedNumber
                arr2Prev.seats[j].number = arr1[arr1Index].seats[seatIndex].editedNumber
              }
            } else {
              arr2Seat.seats[j].editedNumber = arr1[arr1Index].seats[seatIndex].editedNumber
              seat.number = arr1[arr1Index].seats[seatIndex].editedNumber 
            }
          }
        }

      }
    }

    mergedArray.push(arr2Seat);
  }

  if(deletedSeats.length > 0) {
    checkDeletedSeats(deletedSeats);
  }

  return mergedArray;
};


//edit functions
let spaceChangeDelay = null;
let rowCountChangeDelay = null;

export const clampSectionNameX = (sectionWidth, nameWidth, desiredX = 0) => {
  if (!Number.isFinite(sectionWidth) || sectionWidth <= 0) return 0;
  if (!Number.isFinite(nameWidth) || nameWidth <= 0) return 0;

  const availableShift = (sectionWidth - nameWidth) / 2;
  if (availableShift <= 0) return 0;

  const normalizedX = Number.isFinite(+desiredX) ? +desiredX : 0;
  return Math.max(-availableShift, Math.min(availableShift, normalizedX));
};

export const normalizeSectionNamePosition = (sectionGroup, desiredX) => {
  if (!sectionGroup) return 0;

  const configs = sectionGroup.attrs?.configs || {};
  const sectionName = sectionGroup.children.find((g) => g.attrs.type === "name");
  if (!sectionName) return 0;

  const { seats, seatSpacing } = configs;
  const sectionWidth = (SEAT.size + 5 + 2 * seatSpacing) * seats - 2 * seatSpacing - 5;
  const sourceX = desiredX === undefined ? (configs.titleShiftX ?? sectionName.x()) : desiredX;
  const clampedX = clampSectionNameX(sectionWidth, sectionName.width(), sourceX);

  sectionName.setAttrs({
    offsetX: sectionName.width() / 2,
    x: clampedX,
  });

  sectionGroup.setAttrs({
    configs: { ...configs, titleShiftX: clampedX },
  });

  return clampedX;
};

export const changeSectionName = (id, configs) => {
  const currentGroup = mainGroups.get(id);
  const { name } = configs;
  const findName = currentGroup.children.find(g => g.attrs.type === 'name');

  findName.text(name);
  const titleShiftX = normalizeSectionNamePosition(currentGroup, configs.titleShiftX);

  const updateConfigs = { ...currentGroup.attrs.configs, name: name, titleShiftX }
  currentGroup.setAttrs({ configs: updateConfigs });
  return titleShiftX;
};

export const fixSectionPosition = (section, seatsBound, left, right, sectionTop, sectionBottom) => {
  const rotation = section.rotation();

  const { rows, seats, seatSpacing, skewValue, rowSpacing, curveValue } = section.attrs.configs;
  if(rotation) {
    section.rotation(0);
  }

  const { seatsBind } = section.attrs;
  let topEmptyRowSize = 0;
  if(seatsBind[0].oldKey || seatsBind[0].oldKey === '' || seatsBind[0].oldKey === null) {
    topEmptyRowSize += SEAT.size + 5 + rowSpacing;
    for(let i = 1; i < seatsBind.length; i++) {
      if(seatsBind[i].oldKey || seatsBind[i].oldKey === '' || seatsBind[i].oldKey === null) {
        topEmptyRowSize += SEAT.size + 5 + rowSpacing;
      } else {
        break
      }
    }
  }

  const sectionFullTop = sectionTop - topEmptyRowSize;

  const sectionNewHeight = sectionBottom - sectionFullTop + SEAT.size;
  const sectionNewSize = seatsBound.getClientRect();
  const sectionWidth = (SEAT.size + 5 + 2 * seatSpacing) * seats - 2 * seatSpacing - 5;
  
  const sectionName = section.children.find((g) => g.attrs.type === "name"); 
  const layerborder = section.children.find((g) => g.attrs.type === "border");
  const coverLayer = section.children.find((g) => g.attrs.type === "cover");
  const appStage = new AppStage();

  

  // const curveSize = left && left.children.length > 0 ? left.children[0].attrs.y - 20 : 0;

  // const skewSize = skewValue < 0 ? skewValue * 3 * (seats - 1) : 0;
  // const shiftY = curveSize && curveSize < 0 ? curveSize  : 0;
  // const specialShift = skewValue != 0 && curveValue > 0 ? maxTop - skewSize  : 0;
 
  seatsBound.setAttrs({
    offsetX: sectionWidth / 2, 
    offsetY: sectionNewHeight   / 2,
    y: -sectionFullTop
  });
  
  if(sectionName) {
     sectionName.setAttrs({ 
      y: 0 - sectionNewHeight / 2 - 20 ,
    });
    normalizeSectionNamePosition(section);
  }
  
  if(left) {
    left.setAttrs({
      x: -sectionWidth / 2 - 22,
      y: -seatsBound.offsetY() -sectionFullTop  
    });
  }
   
  if(right) {
    right.setAttrs({
      x: sectionWidth / 2 + 22 ,
      y: -seatsBound.offsetY() -sectionFullTop 
    });
  }
   
  if(layerborder) {
    layerborder.setAttrs({
      width: sectionWidth  + 10,
      height: sectionNewHeight + 10,
      offsetX: sectionWidth  / 2,
      offsetY: sectionNewHeight   / 2 ,
      x: -5, 
      y: -5,
    });
  }
 
  if(coverLayer) {
    coverLayer.setAttrs({
      width: sectionNewSize.width,
      height: sectionNewHeight,
      offsetX: sectionNewSize.width   / 2,
      offsetY: sectionNewHeight   / 2,
    })
  }
  
  if(rotation) {
    section.rotation(rotation);
  }
}



